import { type ComponentPublicInstance, type StyleValue } from "vue";
import type { OffsetOptions } from "@floating-ui/vue";
import type { AlignedPlacement, Side } from "@floating-ui/utils";

// NOTE: Similar to the `ToggleEvent` for the Popover API, indicating whether it
// is currently shown or hidden.
// See https://developer.mozilla.org/en-US/docs/Web/API/ToggleEvent
export interface PopoverEmits {
  (e: "toggle", value: boolean): void;
  (e: "update:isOpen", value: boolean): void;
}

export interface PopoverProps {
  anchor?: HTMLElement | ComponentPublicInstance | null;
  placement?: Side | AlignedPlacement;
  trigger?: PopoverTrigger;
  margin?: OffsetOptions;
  padding?: number;
  hasTeleport?: boolean;
  hasArrow?: boolean;
  arrowOffset?: number;
  isDisabled?: boolean;
  isOpen?: boolean;
  containerClasses?: StyleValue;
}

export enum PopoverTrigger {
  CLICK = "click",
  MANUAL = "manual",
  HOVER = "hover",
}
